import { useQuery } from 'react-query'
import { premiacaoService } from '../services/premiacaoService'

export function usePremiacao(ano: number | undefined, mes: number | undefined, quinzena: number | undefined) {
  return useQuery(
    ['premiacao', ano, mes, quinzena],
    () => premiacaoService.obterPremiacao(ano!, mes!, quinzena!),
    { enabled: ano !== undefined && mes !== undefined && quinzena !== undefined, staleTime: 2 * 60 * 1000 },
  )
}

export function usePremiacaoDetalhe(
  ano: number | undefined,
  mes: number | undefined,
  quinzena: number | undefined,
  timeId: number | undefined,
) {
  return useQuery(
    ['premiacao-detalhe', ano, mes, quinzena, timeId],
    () => premiacaoService.obterDetalhe(ano!, mes!, quinzena!, timeId!),
    { enabled: !!ano && !!mes && !!quinzena && !!timeId, staleTime: 2 * 60 * 1000 },
  )
}

export function usePremiacaoConferencias(ano: number | undefined, mes: number | undefined, quinzena: number | undefined) {
  return useQuery(
    ['premiacao-conferencias', ano, mes, quinzena],
    () => premiacaoService.listarConferencias(ano!, mes!, quinzena!),
    { enabled: !!ano && !!mes && !!quinzena, staleTime: 60 * 1000 },
  )
}

export function usePremiacaoHistorico(take: number, enabled: boolean) {
  return useQuery(['premiacao-historico', take], () => premiacaoService.listarHistorico(take), {
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}

/** Retorna mês/ano e número da quinzena anterior à data atual (regra alinhada ao backend). */
export function obterPeriodoQuinzenaAnterior(): { ano: number; mes: number; quinzena: number } {
  const hoje = new Date()
  let ano: number
  let mes: number
  let quinzena: number

  if (hoje.getDate() <= 15) {
    const mesAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1)
    ano = mesAnterior.getFullYear()
    mes = mesAnterior.getMonth() + 1
    quinzena = 2
  } else {
    ano = hoje.getFullYear()
    mes = hoje.getMonth() + 1
    quinzena = 1
  }

  return { ano, mes, quinzena }
}

/** @deprecated Use obterPeriodoQuinzenaAnterior — mantido para telas que ainda derivam datas. */
export function obterDatasQuinzenaAnterior(): { dataInicio: string; dataFim: string } {
  const { ano, mes, quinzena } = obterPeriodoQuinzenaAnterior()
  if (quinzena === 1) {
    const dataInicio = `${ano}-${String(mes).padStart(2, '0')}-01`
    const dataFim = `${ano}-${String(mes).padStart(2, '0')}-15`
    return { dataInicio, dataFim }
  }
  const ultimoDia = new Date(ano, mes, 0).getDate()
  const dataInicio = `${ano}-${String(mes).padStart(2, '0')}-16`
  const dataFim = `${ano}-${String(mes).padStart(2, '0')}-${ultimoDia}`
  return { dataInicio, dataFim }
}
